import { useLocation, Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Flex, Box } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import { useTenantContext } from '@duke-hq/app-provider-web/tenant/TenantContext';
import { useAuthTenant } from '@duke-hq/app-provider-web/tenant/useAuthTenant';
import { useNavButton } from '@duke-hq/ui/components/MainSidebar/useNavButton';
import { useIsWiderThan940px } from '@duke-hq/ui/components/hooks/useIsWiderThan940px';
import { Navbar } from '../Navbar';
import { ErrorBoundary } from '@duke-hq/app-provider-web/components/ErrorBoundary';
import { SideBarNavButtonsConsultant } from '../SidebarTenant';
import { getProviderTitle } from '../pageTitle';
import { sizeVars } from '@duke-hq/ui/constants/layout';
import { testIds } from './testIds';

export function ProviderMainLayout() {
  const tenantCtx = useTenantContext();
  const { user } = useAuthTenant();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.defaultSiteLocation) {
      navigate('/activation');
    }
  }, [user, navigate]);

  const location = useLocation();
  const { expanded } = useNavButton();
  const [isLargerThan940] = useIsWiderThan940px();

  // @ts-expect-error - existing error
  const tenantName = tenantCtx.settings.name;
  const currentPage = location.pathname.split('/')[1];

  let title = getProviderTitle(currentPage);
  title += `${tenantName} ~ Duke`;

  const expandedWidth = `calc(100vw - ${sizeVars.sidebarExpanded})`;
  const collapsedWidth = `calc(100vw - ${sizeVars.sidebarCollapsed})`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Navbar />
      <Flex
        justify="flex-start"
        width="full"
        bgColor="bg.surface"
        height="full"
        data-testid={testIds.Main}
      >
        <ErrorBoundary>
          <SideBarNavButtonsConsultant />
          <Box
            w={expanded && isLargerThan940 ? expandedWidth : collapsedWidth}
            maxW={expanded && isLargerThan940 ? expandedWidth : collapsedWidth}
            maxH={`calc(100vh - ${sizeVars.navbar})`}
            overflow="auto"
          >
            <Outlet />
          </Box>
        </ErrorBoundary>
      </Flex>
    </>
  );
}
